<div class="infoBox">
  <div class="close" *ngIf="isMobile" (click)="dialog.closeAll()">
    <i class="fas fa-times-circle"></i>
  </div>
  <div class="loading" *ngIf="!playerData.pp && (summary == null || summary.playerDetail == null)">
    <img class="loadingGif" src="assets/images/loadinganim.gif" alt="Loading...">
  </div>
  <div class="body">
    <div class="headers">
      <div class="top-part" [ngClass]="{'no-action': (!isMobile || (isDraft && positions.length && picker_id == lgm_id) || (isRanking && (player?.selected == null || player?.selected == false))) == false }" [ngStyle]="{'background-color': teamColors[0]}">
        <div class="top-nav">
          <button mat-button class="box-left" *ngIf="players.length && playerIndex > 0" (click)="prevPlayer()"><i class="fa fa-chevron-left" aria-hidden="true"></i>Prev Player</button>
          <button mat-button class="box-leftD" *ngIf="!players.length || playerIndex <= 0"><i class="fa fa-chevron-left" aria-hidden="true"></i>Prev Player</button>
          <button mat-button class="box-right" *ngIf="players.length && playerIndex < players.length - 1" (click)="nextPlayer()">Next Player<i class="fa fa-chevron-right" aria-hidden="true"></i></button>
          <button mat-button class="box-rightD" *ngIf="!players.length || playerIndex >= players.length - 1">Next Player<i class="fa fa-chevron-right" aria-hidden="true"></i></button>  
        </div>
        <div class="left">
          <div id="player-pic" *ngIf="playerData.pp">
            <div class="player_img" [ngClass]="{'defaultImg': (playerData?.pp == 'default.png')}"
              [ngStyle]="{'background-image':'url(\''+playerURL+playerData?.pp+'?v='+imgversion+'\')'}"></div>
          </div>
          <div id="player-info">
            <div class="pname" *ngIf="playerData.fn">{{ playerData?.fn + ' ' + playerData?.ln }}<span
                class="uniform"
                *ngIf="league.game_id != 5 && summary?.playerDetail?.uniform > 0">#{{ summary?.playerDetail?.uniform }}</span>
            </div>
            <div *ngIf="summary == null || summary.playerDetail == null">
              <i class="fas fa-spinner fa-spin" [ngStyle]="{'color':'#FFFFFF'}"></i>
            </div>
            <div *ngIf="summary != null && summary.playerDetail != null">
              <div class="ppos">
                <span *ngIf="league.game_id != 5">
                  {{ summary?.playerDetail?.location }} {{ summary?.playerDetail?.nickname }} | {{ (summary?.playerDetail?.pn).replace(',', ', ') }}
                </span>
                <span class="injury" *ngIf="player != null && player?.inj != null && player?.inj == 'Y'">
                  <i class="fas fa-exclamation-triangle"></i> {{ (player?.it != null)?player?.it:'' }}
                </span>
              </div>
              <div class="next" *ngIf="summary?.nextGameData.player_location">Next
                Game: {{ (summary?.nextGameData.player_location == 'away')?'@':'vs.' }}
                {{ summary?.nextGameData.team_abbr.toUpperCase() }} ({{ summary?.nextGameData.date_time }})</div>
            </div>
          </div>
        </div>
        <div class="right">
          <ng-container *ngIf="isDraft && positions.length && picker_id == lgm_id">
            <div class="positions">
              Draft as:   
              <mat-form-field class="positionDropdown">
                <mat-select [(value)]="draftedPosition">
                  <mat-option *ngFor="let position of positions" [value]="position">{{ position }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="draftBtn">
              <button mat-button class="draft" (click)="draftPlayer()">Draft</button>
            </div>
          </ng-container>
          <ng-container *ngIf="isRanking && (player?.selected == null || player?.selected == false)">
            <div class="draftBtn rankingAdd">
              <button mat-button class="draft" (click)="addToMyRanking(player)">Add</button>
            </div>
          </ng-container>
        </div>
        <div id="player-row" [ngStyle]="{'background-color': teamColors[1]}"></div>
        <div id="player-sec-row" [ngStyle]="{'background-color': teamColors[1]}"></div>
        <div style="clear: both;"></div>  
      </div>
      <div class="bottom-part">
        <mat-tab-group [(selectedIndex)]="selectedTab" (selectedTabChange)="changeTab($event)">
          <mat-tab label="Summary">
            <div *ngIf="summary?.summaryTheadTable == null">
              <h4 class="text-center">Loading...</h4>
            </div>
            <div> 
              <perfect-scrollbar class="maxHei700"  [ngClass]="summary && summary?.summaryTable == ''?'':'minHeight150'" [config]="{}" style="max-width: 100%;">
                <table class="table statTable">
                  <thead>
                    <tr class="header-postions" *ngIf="summary?.summaryGroupTable != null && summary?.summaryGroupTable.length">
                      <th [ngClass]="{'statsEnd': pos.label}" *ngFor="let pos of summary?.summaryGroupTable; let i = index" [attr.colspan]="pos.colspan">
                        <span *ngIf="(pos.label)">{{pos.label}}</span> &nbsp;
                      </th> 
                    </tr>
                    <tr *ngIf="summary?.summaryTheadTable != null && summary?.summaryTheadTable.length">
                      <th class="label" *ngFor="let label of summary?.summaryTheadTable; let i = index" matTooltip="{{(summary.summaryTheadLabels[label]) ? summary.summaryTheadLabels[label] : ''}}" matTooltipPosition="above">
                        {{ label }}
                      </th> 
                    </tr>
                  </thead> 
                  <tbody class="table" *ngIf="summary?.summaryTable != null && summary?.summaryTable.length">
                    <tr *ngFor="let row of summary?.summaryTable">
                      <td class="col" [ngClass]="textFontClass(row[col], i)" *ngFor="let col of summary?.summaryCols; let i = index">
                        {{ (i > 0 || row[col] != '0')?row[col]:'' }}
                      </td> 
                    </tr>
                    <tr *ngIf="summary.summaryTfootCols">
                      <ng-container *ngFor="let col of summary?.summaryTfootCols; let i = index">
                        <td class="col textBold" [ngClass]="{'leftAligned':i==0}" *ngIf="appendColumn(i)"  [attr.colspan]="addColspan(i)">
                          {{ summary?.summaryTfootTable[col] }}
                        </td>  
                      </ng-container>
                    </tr>
                    <tr *ngIf="summary.summaryAvgCols">
                      <ng-container *ngFor="let col of summary?.summaryAvgCols; let i = index">
                        <td class="col textBold" [ngClass]="{'leftAligned':i==0}" *ngIf="appendColumn(i)"  [attr.colspan]="addColspan(i)">
                          {{ (summary?.summaryAvgTable[col] != '0')?summary?.summaryAvgTable[col]:'0.00' }}
                        </td>  
                      </ng-container>
                    </tr>
                  </tbody>
                </table> 
              </perfect-scrollbar>
              <div *ngIf="summary && summary?.summaryTable == ''" class="text-center minHeight150">No record found</div>
            </div>
            <div class="news">
              <div class="title">Latest News</div>
              <div class="item" *ngFor="let item of summary?.news">
                <mat-expansion-panel class="panel" (opened)="item.panelState = true" (closed)="item.panelState = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="panelTitle">
                      {{ item.created }}
                    </mat-panel-title>
                    <mat-panel-description class="panelDescription">
                      {{ item.summary }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  {{ item.detail }}
                </mat-expansion-panel>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Game Logs">
            <div *ngIf="gameLogs?.summaryTheadTable == null">
              <h4 class="text-center">Loading...</h4>
            </div>
            <div> 
              <perfect-scrollbar [config]="{}" style="max-width: 100%; max-height: 350px;">
                <table class="table statTable">
                  <thead>
                    <tr class="header-postions" *ngIf="gameLogs?.summaryGroupTable != null && gameLogs?.summaryGroupTable.length">
                      <th [ngClass]="{'statsEnd': pos.label}" *ngFor="let pos of gameLogs?.summaryGroupTable; let i = index" [attr.colspan]="pos.colspan">
                        <span *ngIf="(pos.label)">{{pos.label}}</span> &nbsp;
                      </th> 
                    </tr>
                    <tr *ngIf="gameLogs?.summaryTheadTable != null && gameLogs?.summaryTheadTable.length">
                      <th class="label" *ngFor="let label of gameLogs?.summaryTheadTable; let i = index" matTooltip="{{(gameLogs.summaryTheadLabels[label]) ? gameLogs.summaryTheadLabels[label] : ''}}" matTooltipPosition="above">
                        {{ label }}
                      </th> 
                    </tr>
                  </thead> 
                  <tbody class="table" *ngIf="gameLogs?.summaryTable != null && gameLogs?.summaryTable.length">
                    <tr *ngFor="let row of gameLogs?.summaryTable">
                      <td class="col" [ngClass]="textFontClass(row[col], i)" *ngFor="let col of gameLogs?.summaryCols; let i = index">
                        {{ (i > 0 || row[col] != '0')?row[col]:'' }}
                      </td> 
                    </tr>
                  </tbody> 
                </table> 
              </perfect-scrollbar>
              <div *ngIf="gameLogs && gameLogs?.summaryTable == ''" class="text-center">No record found</div>
            </div>
          </mat-tab>
          <mat-tab label="News">
            <div class="news">
              <div class="title">All Player News</div>
                <perfect-scrollbar [config]="{}" style="max-width: 100%; max-height: 300px;">
                  <div class="item" *ngFor="let item of news.news">
                    <mat-expansion-panel class="panel" (opened)="item.panelState = true" (closed)="item.panelState = false">
                      <mat-expansion-panel-header>
                        <mat-panel-title class="panelTitle">
                          {{ item.created }}
                        </mat-panel-title>
                        <mat-panel-description class="panelDescription">
                          {{ getItemSummary(item) }}
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                      {{ item.detail }}
                    </mat-expansion-panel>
                  </div>
                </perfect-scrollbar>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    <div class="footer">Player news and projections provided by <a href="https://www.rotowire.com/" target="_blank">Rotowire.com</a></div>
  </div>
</div>